/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from "react";

export const AccessibleHeadingNode = ({ level, textContent, style }) => {
  if (level === 0) {
    return (
      // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
      <div role="heading" tabIndex="-1" style={style}>
        {textContent}
      </div>
    );
  }
  const Tag = `h${level}`;
  return (
    <Tag tabIndex="-1" style={style}>
      {textContent}
    </Tag>
  );
};
